export class TitleWithModal {
  public icon: string;
  public subTitle: string;
  public modalData: string;
  public modalTitle: string;
  public value: string;
  public automationClass: string;

  constructor(subTitle: string, value: string, modalTitle= '', modalData= '', icon= '', automationClass= 'Auto_Title') {
    this.setTitle(subTitle, value, icon);
    this.setModal(modalTitle, modalData);
    this.automationClass = automationClass;
  }

  public setTitle(subTitle: string, value: string, icon: string) {
    this.subTitle = subTitle;
    this.value = value;
    this.icon = icon;
  }

  public setModal(title: string, value: string) {
    this.modalTitle = title;
    this.modalData = value;
  }
}
